import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'unitizers' });

export const { find, create, get, patch, reducer, remove, update } = actions;

export default reducer;
